<template>
  <div class="notifications">
    <div class="warningBlock" v-if="appMode === 'staging'">
      Aplicação em modo de testes. Toda a informação é fictícia.
    </div>
    <div
      class="warningBlock"
      v-if="sendMessages.value === 'false' && $route.name !== 'messageSettings'"
    >
      O envio automático de mensagens encontra-se inactivo.
      <router-link :to="{ name: 'messageSettings' }" v-slot="{ navigate }" custom>
        <button class="small" @click="navigate">Alterar</button>
      </router-link>
    </div>
    <div class="warningBlock" v-if="offline">
      Ligação à internet perdida. Verifique a ligação do seu dispositivo.
    </div>
    <div class="warningBlock" v-if="versionMismatch">
      A aplicação foi atualizada. Atualize a página assim que possível.
      <a href="#" @click.prevent="reload">Atualizar</a>
    </div>
    <div class="warningBlock" v-if="isAdminOrEditor && pronobisImportStatusVisible">
      {{ pronobisImportMessage }}
      <router-link :to="{ name: 'transactionImporterList' }" v-slot="{ navigate }" custom>
        <button type="button" class="small checkErrors" @click="navigate">Ver</button>
      </router-link>
      <button type="button" class="small" @click="dismissPronobisImportStatus">Descartar</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'NotificationsComponent',
  data: function () {
    return {
      sendMessagesId: '',
      appMode: import.meta.env.VITE_MODE,
    }
  },
  computed: {
    ...mapState({
      settingsById: (state) => state.settings.listById.default,
      offline: (state) => state.offline,
      versionMismatch: (state) => state.versionMismatch,
      pronobisImportStatus: (state) => state.pronobisImportStatus,
    }),
    ...mapGetters({
      isLoggedin: 'auth/isLoggedin',
      pronobisImportStatusVisible: 'pronobisImportStatus/visible',
    }),
    sendMessages() {
      if (typeof this.settingsById[this.sendMessagesId] !== 'undefined') {
        return this.settingsById[this.sendMessagesId]
      }
      return true
    },
    userRole() {
      if (typeof this.$store.state.auth.jwt.CustomUserInfo === 'undefined') {
        return null
      }
      return this.$store.state.auth.jwt.CustomUserInfo.Role
    },
    isAdminOrEditor() {
      return this.$store.getters['auth/isAdminOrEditor']
    },
    pronobisImportMessage() {
      const s = this.pronobisImportStatus
      const parts = []
      if (s.parseErrorCount > 0) {
        parts.push(`${s.parseErrorCount} linhas com valores ilegíveis`)
      }
      if (s.unresolvedCount > 0) {
        parts.push(`${s.unresolvedCount} linhas por atribuir a um centro de custo`)
      }
      return `A última importação Pronobis tem ${parts.join(' e ')}.`
    },
  },
  methods: {
    ...mapActions({
      getSettingsList: 'settings/list',
      setOffline: 'setOffline',
      dismissPronobisImportStatus: 'pronobisImportStatus/dismiss',
    }),
    reload() {
      window.location.reload()
    },
    findSendMessagesId() {
      Object.keys(this.settingsById).find((id) => {
        const setting = this.settingsById[id]
        if (setting.name === 'SendMessages') {
          this.sendMessagesId = id
          return true
        }
        return false
      })
    },
    setOfflineLocal() {
      this.setOffline(true)
    },
    setOnlineLocal() {
      this.setOffline(false)
    },
  },
  created() {
    if (
      this.$route.name !== 'login' &&
      this.$route.name !== 'notFound' &&
      this.$route.name !== 'recover'
    ) {
      this.findSendMessagesId()
    }
    window.addEventListener('offline', this.setOfflineLocal)
    window.addEventListener('online', this.setOnlineLocal)
  },
  unmounted() {
    window.removeEventListener('offline', this.setOfflineLocal)
    window.removeEventListener('online', this.setOnlineLocal)
  },
}
</script>

<style lang="scss" scoped>
.notifications {
  text-align: center;
  .warningBlock {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.checkErrors {
  margin-left: 2ch;
  margin-right: 0;
  min-width: 8ch;
}
</style>
